<template src="./printqrcode.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";
  import QrCode from "@/pages/assets/qrcode/qrcode.vue";

  export default {
    components: { QrCode },
    data() {
      return {
        ShowLoader: false,
        AssetId: 0,
        AssetData: {}
      };
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Asset QR Code";
      this.AssetId = this.$route.params.Id;
      setTimeout(() => {
        this.GetAssetDetail();
      }, 1000);
    },
    methods: {
      PrintReport() {
        window.print();
      },
      GetAssetDetail() {
      this.ShowLoader = true;
      Axios.post(Endpoints.Assets.Get, {
        token: localStorage.getItem("token"),
        Assets_id: this.AssetId,
      }).then((Response) => {
        this.ShowLoader = false;
        if (Response?.data?.success) {
          this.AssetData = Response.data.record;
        }
      });
    },
    },
  };
</script>
<style scoped>
.qr-code-text{
  font-size: 14px;
  font: bold;
}
  @media print {
    .print_btn {
      display: none;
    }
  }
</style>
